/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { arsenal_army } from '../models/arsenal_army';
import type { arsenal_army_all } from '../models/arsenal_army_all';
import type { arsenal_army_dto } from '../models/arsenal_army_dto';
import type { arsenal_army_last_update } from '../models/arsenal_army_last_update';
import type { arsenal_step } from '../models/arsenal_step';
import type { arsenal_step_dto } from '../models/arsenal_step_dto';
import type { arsenal_unit } from '../models/arsenal_unit';
import type { arsenal_unit_dto } from '../models/arsenal_unit_dto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ArsenalService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get my model armies with full informations
   * @returns arsenal_army_all successful
   * @throws ApiError
   */
  public getMyArmies({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<arsenal_army_all>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/arsenal/armies',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Create the model army
   * @returns arsenal_army successful
   * @throws ApiError
   */
  public createArmy({
    locale,
    requestBody,
  }: {
    /**
     * Current locale
     */
    locale: string;
    requestBody?: arsenal_army_dto;
  }): CancelablePromise<arsenal_army> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/arsenal/armies',
      path: {
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Update the army
   * @returns arsenal_army successful
   * @throws ApiError
   */
  public updateArmy({
    id,
    locale,
    requestBody,
  }: {
    /**
     * Army identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
    requestBody?: arsenal_army_dto;
  }): CancelablePromise<arsenal_army> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/arsenal/armies/{id}',
      path: {
        id: id,
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete the army
   * @returns void
   * @throws ApiError
   */
  public deleteArmy({
    id,
    locale,
  }: {
    /**
     * Army identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/{locale}/api/v1/arsenal/armies/{id}',
      path: {
        id: id,
        locale: locale,
      },
    });
  }
  /**
   * Get the army
   * @returns arsenal_army successful
   * @throws ApiError
   */
  public getArsenalArmy({
    id,
    locale,
  }: {
    /**
     * Army identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<arsenal_army> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/arsenal/armies/{id}',
      path: {
        id: id,
        locale: locale,
      },
    });
  }
  /**
   * Get Arsenal armies by Army Category
   * @returns arsenal_army successful
   * @throws ApiError
   */
  public getByArmyCategoryId({
    armyCategoryId,
    locale,
  }: {
    /**
     * Army Category identifier
     */
    armyCategoryId: number;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<arsenal_army> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/arsenal/armies/army_categories/{army_category_id}',
      path: {
        army_category_id: armyCategoryId,
        locale: locale,
      },
    });
  }
  /**
   * Get armies with updated_at
   * @returns arsenal_army_last_update successful
   * @throws ApiError
   */
  public getUpdatedAtArsenalArmies({
    locale,
  }: {
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<Array<arsenal_army_last_update>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/{locale}/api/v1/arsenal/armies/last_update',
      path: {
        locale: locale,
      },
    });
  }
  /**
   * Create a step
   * @returns arsenal_step successful
   * @throws ApiError
   */
  public createUnitStep({
    id,
    locale,
    requestBody,
  }: {
    /**
     * Unit identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
    requestBody?: arsenal_step_dto;
  }): CancelablePromise<arsenal_step> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/arsenal/units/{id}/unit_steps',
      path: {
        id: id,
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Update the unit step
   * @returns arsenal_step successful
   * @throws ApiError
   */
  public updateUnitStep({
    id,
    locale,
    requestBody,
  }: {
    /**
     * Unit identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
    requestBody?: arsenal_step_dto;
  }): CancelablePromise<arsenal_step> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/arsenal/unit_steps/{id}',
      path: {
        id: id,
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Create the unit
   * @returns arsenal_unit successful
   * @throws ApiError
   */
  public createUnit({
    id,
    locale,
    requestBody,
  }: {
    /**
     * Army identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
    requestBody?: arsenal_unit_dto;
  }): CancelablePromise<arsenal_unit> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/{locale}/api/v1/arsenal/armies/{id}/units',
      path: {
        id: id,
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Update the unit
   * @returns arsenal_unit successful
   * @throws ApiError
   */
  public updateUnit({
    id,
    locale,
    requestBody,
  }: {
    /**
     * Unit identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
    requestBody?: arsenal_unit_dto;
  }): CancelablePromise<arsenal_unit> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/{locale}/api/v1/arsenal/units/{id}',
      path: {
        id: id,
        locale: locale,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
  /**
   * Delete the unit
   * @returns void
   * @throws ApiError
   */
  public deleteUnit({
    id,
    locale,
  }: {
    /**
     * Unit identifier
     */
    id: string;
    /**
     * Current locale
     */
    locale: string;
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/{locale}/api/v1/arsenal/units/{id}',
      path: {
        id: id,
        locale: locale,
      },
    });
  }
}
